import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Input, Spin } from "antd";
import FlexTable from "../common/FlexTable";
import { useQuery } from "@tanstack/react-query";
import { getAppointmentsAdmin } from "../../../network/admin";
import dayjs from "dayjs";

type Props = {
  selectedDate: string;
};

const DailyAppointments = ({ selectedDate }: Props) => {
  const [search, setSearch] = useState("");
  const { data, isLoading } = useQuery(
    ["appointment", selectedDate, search],
    () =>
      getAppointmentsAdmin({
        page: 1,
        "date_range[from]": selectedDate,
        "date_range[to]": selectedDate,
        ...(isNaN(+search) ? { search } : { appointment_id: search }),
      }),
    {
      select: (res) => res.data,
      refetchInterval: 20000,
    }
  );
  console.log(data, "data");
  const cols = ["#", "Salon", "Status", "time"];

  return (
    <div className="w-full h-fit bg-white min-h-[680px] p-6 rounded-lg flex flex-col gap-[18px]">
      <div className="w-full flex items-center justify-between">
        <h4 className="text-color-primary text-lg font-semibold">
          Today’s Appointments
        </h4>
        <Link
          className="text-color-primary px-4 py-2 rounded-2xl bg-[#EEF0FF] font-medium text-sm"
          to="/admin/appointments"
        >
          Show all
        </Link>
      </div>
      <Input
        size="small"
        placeholder={"Search"}
        className="w-full rounded-xl py-2 px-4 bg-[#F4F7FE]"
        value={search}
        onChange={(e) => {
          if (e.target.value?.includes("#")) {
            setSearch(e.target.value?.replace("#", ""));
          } else {
            setSearch(e.target.value);
          }
        }}
        prefix={<SearchOutlined className="text-color-primary mr-2" />}
        style={{ paddingRight: 30 }} // Increase paddingRight to accommodate the icon
      />
      {isLoading ? (
        <div className="w-full h-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      ) : (
        <FlexTable cols={cols} data={data} isDivider={true} type={""} />
      )}
    </div>
  );
};

export default DailyAppointments;
